import styled from 'styled-components';
import { baseVariables } from '../../styles/baseVariables';
import { MContentSwapAlignment } from './MContentSwap.types';

const { spacers } = baseVariables;

export const Wrapper = styled.div<{ $alignment?: MContentSwapAlignment }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${spacers?.spacers?.[3] ?? '1rem'};
  justify-content: ${({ $alignment }) => ($alignment === MContentSwapAlignment.Centered ? 'center' : 'flex-start')};

  > * {
    flex-shrink: 0;
  }
`;
